import apollo from '@/graphql'

import GetDeal from '@/graphql/deal/DealDetails.gql'
import GetHubspotData from '@/graphql/deal/HubspotData.gql'
import SaveDeal from '@/graphql/deal/SaveDeal.gql'
import GetDealCampaigns from '@/graphql/deal/DealCampaigns.gql'

// initial state
const state = {
  dealCampaigns: [],
  dealDetails: {},
  isDealLoading: false,
  isDealSaving: false,
}

// getters
const getters = {
  dealCampaigns: st => st.dealCampaigns,
  dealDetails: st => st.dealDetails,
  hubspotData: st => st.hubspotData,
  isDealLoading: st => st.isDealLoading,
  isDealSaving: st => st.isDealSaving,
}

// mutations
const mutations = {
  setDealCampaigns(st, dealCampaigns) {
    state.dealCampaigns = dealCampaigns
  },
  setDealDetails(st, dealDetails) {
    state.dealDetails = dealDetails
  },
  setDealLoading(st, isDealLoading) {
    state.isDealLoading = isDealLoading
  },
  setDealSaving(st, isDealSaving) {
    state.isDealSaving = isDealSaving
  },
  setHubspotData(st, hubspotData) {
    state.hubspotData = hubspotData
  },
  saveDeal(st, dealDetails) {
    state.dealDetails = dealDetails
  },
}

// actions
const actions = {
  async getDeal({ commit }, { id, useHubspot }) {
    commit('setDealLoading', true)
    await apollo.defaultClient
      .query({
        fetchPolicy: 'network-only',
        query: GetDeal,
        variables: { id: +id, useHubspot },
      })
      .then(({ data: { getDeal } }) => {
        commit('setDealDetails', getDeal)
        commit('setDealLoading', false)
      })
      .catch((err) => {
        commit('setDealLoading', false)
        throw new Error(err.graphQLErrors[0].message)
      })
  },

  async getDealCampaigns({ commit }, { id }) {
    await apollo.defaultClient
      .query({
        fetchPolicy: 'network-only',
        query: GetDealCampaigns,
        variables: { id: +id },
      })
      .then(({ data: { getDealCampaigns } }) => {
        commit('setDealCampaigns', getDealCampaigns)
      })
      .catch((err) => {
        throw new Error(err.graphQLErrors[0].message)
      })
  },

  async getHubspotData({ commit }, { id }) {
    commit('setDealLoading', true)
    await apollo.defaultClient
      .query({
        query: GetHubspotData,
        variables: { id },
      })
      .then(({ data: { getHubspotData } }) => {
        commit('setHubspotData', getHubspotData)
        commit('setDealLoading', false)
      })
  },

  async saveDeal({ commit }, variables) {
    commit('setDealSaving', true)

    await apollo.defaultClient
      .mutate({
        mutation: SaveDeal,
        variables,
      })
      .then(({ data: { saveDeal: { id } } }) => {
        commit('setDealSaving', false)
        return id
      })
      .catch((err) => {
        commit('setDealSaving', false)
        throw new Error(err.graphQLErrors[0].message)
      })
  },
}

export default {
  state,
  getters,
  mutations,
  actions,
}



// WEBPACK FOOTER //
// ./src/store/modules/deal/DealDetails.js